var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.questions
    ? _c(
        "div",
        { attrs: { id: "exercisePrint" } },
        [
          _c(
            "button",
            {
              staticClass: "print-report-btn",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.print.apply(null, arguments)
                },
              },
            },
            [_vm._v("הדפסה")]
          ),
          _vm.isMultipleQuestions
            ? _c("div", { staticClass: "exercise-title" }, [
                _c("div", { staticStyle: { "font-size": "2em" } }, [
                  _vm._v("שאלות בתרגול"),
                ]),
              ])
            : _c("div", { staticClass: "exercise-title" }, [
                _c("div", { staticStyle: { "font-size": "2em" } }, [
                  _vm._v("תרגול: "),
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(_vm._s(_vm.exerciseName)),
                  ]),
                ]),
                _c("div", { staticStyle: { "font-size": "2em" } }, [
                  _vm._v("מתוך: " + _vm._s(_vm.categoryName || "")),
                ]),
              ]),
          _vm._l(_vm.questions, function (question, index) {
            return _vm.questions
              ? _c(
                  "div",
                  {
                    key: question.id,
                    staticClass: "question",
                    class: { "with-detailed-answer": question.detailedAnswer },
                  },
                  [
                    _c("div", { staticClass: "question-header" }, [
                      _c("b", [_vm._v(_vm._s(index + 1) + ".")]),
                      _c("span", {
                        staticClass: "question-text",
                        domProps: { innerHTML: _vm._s(question.question) },
                      }),
                    ]),
                    _vm._l(question.answers, function (answer) {
                      return _c(
                        "div",
                        { staticClass: "answer" },
                        [
                          _c("span", { staticClass: "dot" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm._f("letterize")(answer.sortOrder))
                              ),
                            ]),
                          ]),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(answer.answer) },
                          }),
                          answer.isCorrect
                            ? _c("b-icon", {
                                staticStyle: { color: "green" },
                                attrs: { icon: "check" },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    question.detailedAnswer
                      ? _c("div", { staticClass: "questionText" }, [
                          _c("div", [_vm._v("תשובה מפורטת")]),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(question.detailedAnswer),
                            },
                          }),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e()
          }),
          _c("div", { staticClass: "signature" }, [
            _vm._v("הודפס ממערכת הסימולטור - המתמחה מבית נבו"),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }